import React from 'react';
import { Formik, Form, Field, useFormik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Yup from "yup";
import * as dataSeed from '../shared/DataSeed';
import { withRouter } from 'react-router-dom';
import { Persist } from 'formik-persist';

import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert, FormFeedback,
    Fade, ModalHeader
} from 'reactstrap';
import { bankValidationActions } from '../store/BcaValidation.Reducer';

class Page1Email extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            load: false,
            error: false,
            success: -1,
            message: 'Gagal Validasi',
            norek: localStorage.getItem('norek') || '',
            nama: localStorage.getItem('nama') || '',
            pilihBank: localStorage.getItem('pilihBank') || '',
            kepemilikanAsset: localStorage.getItem('kepemilikanAsset') || '1',
            agreementCheck: false,
            agreementBO: false,
            validationCode: '',
            isLoading: false,
            openModal: false,
            fotoSpecimen: '',
            imageHash: '', //Date.now(),
            trimmedDataURL: null

        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        localStorage.clear();
    }


    Step1Schema = Yup.object().shape({
        Email: Yup.string().required('Email tidak boleh kosong').email('Email tidak valid'),
        EmailConfirmation: Yup.string().required('Konfirmasi Email tidak boleh kosong').email('Email tidak valid').equalTo(Yup.ref('Email'))
    });

    handleChange(event, setFieldValue) {
        const name = event.target.name;
        const value = event.target.value;
        setFieldValue(name, value);
        this.setState({ [name]: value });
        //localStorage.setItem(name, value);
    }

    handleSubmit = (values, { setSubmitting }) => {
        this.props.history.push('/bank');
        setSubmitting(false);
    }

    onBtnClick = () => {

    }


    render() {

        const { errors, touched, setFieldValue, setFieldTouched, values, bcaValidation, isValid, onEmailKonfirmationClick, state, onAgree } = this.props;

        let msgAlert, verifikasiButton;

        verifikasiButton = <Button type="button" color="primary" onClick={this.props.nowPilihBank} className="btn-block" >Pilih</Button>;

        return (
            <React.Fragment>
                <Modal isOpen={bcaValidation.isLoading}>
                    <ModalBody className="text-center">
                        <Spinner color="success" /><br />Loading..
                    </ModalBody>
                </Modal>


                <Fade in={true}>

                    <UncontrolledAlert color="warning">Sebelum melanjutkan mohon mempersiapkan dokumen pendukung KTP.</UncontrolledAlert>
                    <p className="text-danger"><b>Sebaiknya menggunakan browser Chrome / Firefox / Safari</b></p>
                    <p className="text-h6">Panduan Pembukaan Rekening online <a href="https://yb.co.id/howtoregist" target="__blank">Klik disini</a></p>
                    {msgAlert}

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Email<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="Email" type="email" bsSize="sm"
                                    onChange={(e) => this.handleChange(e, setFieldValue)}
                                    invalid={errors.Email && touched.Email} />
                                {errors.Email && touched.Email ? (
                                    <FormFeedback>{errors.Email}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Konfirmasi Email<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="EmailConfirmation" type="email" bsSize="sm"
                                    onChange={(e) => this.handleChange(e, setFieldValue)}
                                    invalid={errors.EmailConfirmation && touched.EmailConfirmation} />
                                {errors.EmailConfirmation && touched.EmailConfirmation ? (
                                    <FormFeedback>{errors.EmailConfirmation}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="checkbox"
                                        name="Agreement"
                                        tag={Field}
                                        checked={values.Agreement}
                                        onClick={(e) => onAgree(e, setFieldValue)} 
                                    />{' '}
                                    Saya menyatakan bahwa saya telah membaca, memahami, dan menyetujui <a href="https://www.yb.co.id/privacy-policy">Kebijakan Privasi PT Yakin Bertumbuh Sekuritas</a>. Saya memberikan persetujuan kepada PT Yakin Bertumbuh Sekuritas untuk:
                                    <ul>
                                        <li>Mengumpulkan data pribadi saya sebagaimana tercantum dalam formulir
                                            pembukaan rekening efek;</li>
                                        <li>Menyimpan dan memproses data pribadi saya untuk keperluan pembukaan dan
                                            pengelolaan rekening efek, serta keperluan lain yang sah sesuai dengan peraturan perundang-undangan yang berlaku;</li>
                                        <li>Mengungkapkan data pribadi saya kepada pihak ketiga yang bekerja sama dengan PT Yakin Bertumbuh Sekuritas, sejauh diperlukan untuk mendukung layanan dan tunduk pada ketentuan perlindungan data pribadi.</li>
                                    </ul>
                                    Saya menyadari bahwa saya dapat menarik kembali persetujuan ini sewaktu-waktu dengan menghubungi PT Yakin Bertumbuh Sekuritas melalui saluran layanan yang tersedia, sebagaimana diatur dalam <a href="https://www.yb.co.id/privacy-policy">Kebijakan Privasi PT Yakin Bertumbuh Sekuritas</a>.
                                </Label>
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="row">
                        <div className="col text-right">
                            {(state.isLoading) ?
                                <Button
                                    disabled={!(isValid)}
                                    onClick={() => onEmailKonfirmationClick(isValid, setFieldTouched, setFieldValue, values)}
                                    type="button"
                                    disabled
                                    color="primary"
                                >Konfirmasi &#8594;</Button>
                                :
                                <Button
                                    disabled={!(isValid)}
                                    onClick={() => onEmailKonfirmationClick(isValid, setFieldTouched, setFieldValue, values)}
                                    type="button"
                                    color="primary"
                                >Konfirmasi &#8594;</Button>
                            }
                        </div>
                    </div>
                </Fade>

            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => ({
    bcaValidation: state.bcaValidation
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestBankValidation: bankValidationActions.requestBankValidation
    }, dispatch);
}

export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Page1Email);



// WEBPACK FOOTER //
// ./src/components/Page1Email.js